export default __webpack_public_path__ + "static/media/Nunito-Bold.f4338623.ttf";